import moment from 'moment'

/**
 * Tests whether a scorecard node with the given start and archive dates is
 * visible in a period with the given start and end dates.
 */
function visible(node, period) {
	let start = node.ancestorStart || node.start
	let archive = node.ancestorArchive || node.archive
	// if no start or end defined, the node is visible
	if (!start && !archive) {
		return true
	}

	// handle only an archive date
	var nodeArchive = moment(archive)
	var periodStart = moment(period.start)
	if (!start) {
		return periodStart.isBefore(nodeArchive) || periodStart.isSame(nodeArchive)
	}

	// handle only a start date
	var nodeStart = moment(start)
	var periodEnd = moment(period.end)
	if (!archive) {
		return periodEnd.isAfter(nodeStart) || periodEnd.isSame(nodeStart)
	}

	// handle both a start and end date
	return !periodStart.isAfter(nodeArchive) && !periodEnd.isBefore(nodeStart)
}

export default visible

visible.__filename__ = 'scorecards/visible.js'
